(function () {
    'use strict';

    angular
        .module('rms.common')
        .controller('LoadingDialogCtrl', LoadingDialogCtrl);

    function LoadingDialogCtrl(close, $timeout, dialogOptions, lodash) {
        const vm = this;
        vm.options = dialogOptions.options;
        vm.title = dialogOptions.title;
        vm.message = dialogOptions.message;

        vm.dismiss = function () {
            close(false);
        };


        $timeout(function () {
            vm.show = true;
        });
    }
})();